module.exports = __webpack_public_path__ + "img/img_default_cover_article.3754a878.png";